import React, { useState } from 'react';

import { BotaoMenor, Spinner } from '../StyledComponent';
import { Link } from 'react-router-dom';

import Cognito from '../..//Amplify';
import EmailSent from './EmailSend';
import InfoIcon from '@material-ui/icons/Info';
import Input from '../Reutilizaveis/Input';
import Fade from '@material-ui/core/Fade';

import './styles.scss';

export const ForgotPassword = () => {
  // estados
  const [email, setEmail] = useState('');
  const [sendMail, setSendMail] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(false);
  const [info, setInfo] = useState(false);
  const { forgotPassword } = Cognito;

  async function resetPassword(event) {
    event.preventDefault();

    setLoading(true);

    try {
      await forgotPassword(email.replaceAll(' ', ''));
      setSendMail(true);
    } catch (error) {
      setLoading(false);
      setErrorMessage('Demasiadas tentativas, tenta novamente mais tarde');
    }
  }

  return (
    <div>
      {sendMail ? (
        <Fade>
          <EmailSent key={'emailSentComponent'} email={email} />
        </Fade>
      ) : (
        <div className='loginForm loginForgotPassword centralized-column'>
          <form
            onSubmit={resetPassword}
            className='forgot-password centralized-column'
          >
            <div className='forgot-password__title'>
              <h1>Esqueci minha senha</h1>
            </div>

            <div className='information'>
              <span>
                <InfoIcon
                  id='btnInformation'
                  onClick={(event) => {
                    event.preventDefault();
                    setInfo(!info);
                  }}
                  className='information__icon'
                />
              </span>
            </div>
            <Input
              value={email.replace(/\s/g, '')}
              setValue={setEmail}
              placeholder='e-mail'
              id='userName'
              required='false'
              type='email'
              tamanho='233px'
            />

            {loading ? (
              <Spinner />
            ) : (
              <BotaoMenor
                backgroundcolor='#003DA5'
                id='btnRecoverPassword'
                color='#ffffff'
                type={'submit'}
                disabled={email === '' ? true : false}
                width='100%'
              >
                RECUPERAR MINHA SENHA
              </BotaoMenor>
            )}
          </form>
          {errorMessage}
          <div className='loginForgotPassword__toLogin'>
            <Link
              className='loginForgotPassword__toLogin__link'
              to='/'
              id='btnBackToLogin'
            >
              Retornar ao login
            </Link>
          </div>
          {info ? (
            <div className='errorMsg'>
              <p>
                O aplicativo irá enviar uma notificação para o seu e-mail
                cadastrado em nosso banco caso seja proprietário de um ou mais
                imóveis da <strong>Direcional ou Riva Incorporadora.</strong>
              </p>
              <p>
                Caso não lembre seu e-mail, favor entrar em contato com nosso
                suporte.
              </p>
            </div>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};
